import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import Tooltip from 'react-bootstrap/Tooltip'

const formatDisplayData = (cell, chracterSize) => {
    let maxLength = chracterSize !== undefined && chracterSize !== null && chracterSize !== "" ? chracterSize : 30
    if (cell) {
        // trigger={['hover', 'focus']}
        cell = cell.label !== undefined && cell.label !== null ? cell.label : cell;
        return (
            <React.Fragment>
                <ButtonToolbar>
                    <div >{cell && cell.length > maxLength ? cell.substring(0, maxLength) : cell}</div>
                    <OverlayTrigger
                        trigger={"click"}
                        placement={'auto'}  
                        rootClose
                        overlay={
                            <Tooltip className="tds-max-width-tooltip">
                                {cell.toString()}
                            </Tooltip>
                        }
                    >
                        {
                            cell && cell.length > maxLength?
                            <div className="link">...</div>
                            :
                            <div></div>
                        }
                    </OverlayTrigger>
                </ButtonToolbar>
            </React.Fragment>);
    } else {
        return null
    }
}

export default formatDisplayData;